import { useEffect, useState } from "react";
import { Expandable2 } from "../../../../components/Expandable/Expandable2"
import { useDispatch, useSelector } from "react-redux";
import { addRange, fetchRanges, removeRange, selectCurrencies, selectEditingStatus, selectSelectedVendor, updateCostItem, updateRange } from "../../../../redux/features/configuration/parts/vendorCostSlice";
import { Tag } from "../../../../components/Tags/Tag";
import BasicDatePicker from "../../../../components/Datepicker/Datepicker";
import { Radios } from "../../../../components/RadioGroup/Radios";
import Input from "../../../../components/Inputs/Input";
import { DialogTrigger } from "../../../../components/Dialog/Dialog";
import DeletePartDialog from "./DeletePartDialog";

export const HistoryItem = ({part, item, idx, conditionIdx }) => {

    const [openStatus, setOpenStatus] = useState(false);
    const selectedVendor = useSelector(selectSelectedVendor);
    const idxCurrencies = useSelector(selectCurrencies);
    const currency = idxCurrencies[selectedVendor.currencyId];
    const editingStatus = useSelector(selectEditingStatus);
    const dispatch = useDispatch();

    const editing = editingStatus[selectedVendor.tempId] && ((item.active === 'true' || item.active === true) || item.isNew || isFutureOrToday(item.initialDate));

    const onChange = ({name, value}) => {
    
        dispatch(updateCostItem({vendorTempId:selectedVendor.tempId, conditionIdx, historyIdx:idx, name, value}));

    }

    const handleKeyDown = () => {

    }

    const newRange = () => {
        dispatch(addRange({
            vendorTempId: selectedVendor.tempId, conditionIdx, historyIdx:idx
        }))

    }

    const isRangeBased = item.costType === "R";

    useEffect(() => {
        if (openStatus === true) {
            if (typeof (item.id) === "number") {
                dispatch(fetchRanges({ costHistoryId: item.id, conditionIdx, historyIdx: idx, vendorTempId: selectedVendor.tempId }))
            }
        }
    }, [openStatus]);

    const UpdateRangeEvent = (rangeIdx, e) => {
        let {name, value} = e;
        dispatch(updateRange({
            vendorTempId: selectedVendor.tempId, conditionIdx, historyIdx:idx, name, value, rangeIdx
        }))
    }

    const deleteRange = () => {
        //TODO:

    }

    const discardRange = (at) => {
        //TODO:
        dispatch(removeRange({
            vendorTempId: selectedVendor.tempId, conditionIdx, historyIdx:idx, at
            
        }))
    }

    return (
        <>
            {/* {JSON.stringify(item)} */}

            <Expandable2 onOpenChange={(e) => setOpenStatus(e)} summary={
                <div className={`history-item-component ${openStatus ? 'active' : ''}`}>
                    <span>{item.initialDate ?? "--"}</span>
                    <span>{item.finalDate ?? "--"}</span>

                    <span>$ {item.minUnitCost ?? "--"} {currency?.prefix ?? ""}</span>
                    <div className='actions'>
                        {(item.active || item.isNew) && <>{(typeof (item.active === 'string') ? (item.active === "true") : (item.active === true)) && <Tag type="info" tag={
                            <>
                                <span>Status</span> <b>Active</b>
                            </>
                        } />}
                            {/*
                                editing ?
                                    <MultioptionButton buttons={saveButtons} buttonCallbacks={{
                                        'save': () => saveClick(true),
                                        'save-continue': () => saveClick(false),
                                        'cancel': () => cancelEdition()
                                    }}></MultioptionButton>
                                    :
                                    <i onClick={startEditing} className='icon-edit'></i>
                                    */}

                        </>
                        }

                    </div>
                </div>
            }>

                <div className='history-item-content-component'>
                    <div className='header-item-content'>
                        {/* FIXME: confirm valid from label */}
                        <BasicDatePicker
                            onChange={(newValue) => {
                                onChange({ name: "initialDate", value: newValue?.format("YYYY-MM-DD") || "" })
                            }}
                            maxDate={item.finalDate}
                            value={item.initialDate} disabled={!editing} label="Initial Date" />
                        <BasicDatePicker
                            onChange={(newValue) => {
                                onChange({ name: "finalDate", value: newValue?.format("YYYY-MM-DD") || "" })
                            }}
                            minDate={item.initialDate}
                            value={item.finalDate} disabled={!editing} label="Valid Until" />
                        <Radios disabled={!editing} onChange={(newV) => onChange({name: "costType", value:  newV === 'true' ? "R" : "F" })} value={isRangeBased} name="fixed" items={[{ value: true, label: "Range Based Cost" }, { value: false, label: "Fixed Cost" }]} />
                    </div>
                    <div className='content-item' onKeyUp={handleKeyDown}>
                        {/* {JSON.stringify(part)} */}
                        <div className='headr'>
                            <div className='qty-header'>
                                <b>{isRangeBased ? "Quantity Range" : "Quantity"}</b>
                                {isRangeBased && editing && <button onClick={newRange} className='filled tiny'>
                                    <i className='icon-add-new'></i>
                                    <span>New Range  </span>
                                </button>}
                            </div>

                            <b>Unit Cost</b>
                        </div>

                            {/* {JSON.stringif y(item)} */}
                        {isRangeBased ?
                            item.ranges?.map((r, j) =>
                                <>
                                    <div key={r.id} className='range-item'>
                                        {editing ? 
                                        <div className="range-inputs">
                                            <Input allowDecimals={part?.categoryName === "Consumables"}  isNumeric disableAutocomplete name="rangeMin" onChange={(e) => UpdateRangeEvent(j, e.target)} value={r.rangeMin} label="" />
                                            -
                                            <Input allowDecimals={part?.categoryName === "Consumables"}  isNumeric disableAutocomplete name="rangeMax" onChange={(e) => UpdateRangeEvent(j, e.target)} value={r.rangeMax} label="" />
                                            {part?.categoryName === "Consumables" && <b>{part?.uom?.abreviation}</b>}
                                        </div>
                                        
                                        : <span className="range-inputs">{r.rangeMin} - {r.rangeMax} 
                                            {part?.categoryName === "Consumables" && <b>{part?.uom?.abreviation}</b>}

                                        </span>}
                                        <div className='unit-cost'>
                                            <span>$</span>
                                            {editing ? <Input required disableAutocomplete name="unitCost" onChange={(e) => UpdateRangeEvent(j, e.target)} isNumeric value={r.unitCost} label="" /> : <span>{r.unitCost}</span>}
                                            <b>{currency?.prefix ?? ""}</b>
                                            {editing ?
                                                <>

                                                    {
                                                        (typeof (r.id) === "number") ?

                                                            <DialogTrigger
                                                                dialogContent={{
                                                                    component: DeletePartDialog,
                                                                    props: {
                                                                        item: {},
                                                                        message: `Are you sure you want to delete the range "${r.range}"?`,
                                                                        onDelete: () => deleteRange(r.id)
                                                                    }
                                                                }}
                                                            >
                                                                <i className='icon-delete-new'></i>
                                                            </DialogTrigger> :
                                                            <i className='icon-delete-new' onClick={() => discardRange(j)}></i>
                                                    }
                                                </>

                                                : <div></div>}

                                        </div>
                                    </div>
                                </>

                            )
                            :
                            item.ranges?.length > 0 ? <div className='range-item'>
                                <span>1 Unit</span>
                                <i><i>

                                </i></i>
                                <div className='unit-cost'>
                                    <span>$</span>
                                    {editing ? <Input disableAutocomplete name="unitCost" onChange={(e) => UpdateRangeEvent(0, e.target)} isNumeric value={item.ranges[0].unitCost} label="" /> : <span>{item.ranges[0].unitCost ?? "--"}</span>}
                                    <b>{currency?.prefix ?? ''}</b>
                                </div>
                            </div> : <div className='placeholder-component'>
                                <i></i>
                            </div>
                        }
                    </div>
                </div>

            </Expandable2>
        </>
    )
};

function isFutureOrToday(dateString) {
    const inputDate = new Date(dateString);
    const today = new Date();
    
    // Normalize both dates to remove time differences
    today.setHours(0, 0, 0, 0);
    inputDate.setHours(0, 0, 0, 0);

    return inputDate >= today;
}
